<div class="row" [hidden]="!displayName">
  <div class="col-sm-12 wc-settings-reg-field-name">
    <strong>{{ displayName }}</strong>
  </div>
</div>
<div class="row">
  <div
    class="col-xs-3 col-md-2 wc-settings-reg-field-first-type"
    [ngClass]="offsetClass"
    *ngIf="regVisibleFieldVisible || regRequiredVisible"
  >
    {{ 'common.registration' | translate | titlecase }}
  </div>
  <div class="col-xs-4 col-md-1 text-center">
    <input
      type="checkbox"
      [(ngModel)]="regVisible"
      *ngIf="regVisibleFieldVisible"
      (change)="regVisCheckboxChanged($event)"
      [disabled]="registrationRequiredDisabled"
    />
  </div>
  <div class="col-xs-4 col-md-1 text-center">
    <input
      type="checkbox"
      [(ngModel)]="regRequired"
      *ngIf="regVisibleFieldVisible && regRequiredVisible"
      (change)="regReqCheckboxChanged($event)"
      [disabled]="registrationVisibleDisabled"
    />
  </div>
</div>
<div class="row">
  <div
    class="col-xs-3 col-md-2 wc-settings-reg-field-first-type"
    [ngClass]="offsetClass"
    *ngIf="attVisibleFieldVisible || attRequiredVisible"
  >
    {{ 'common.attendee' | translate | titlecase }}
  </div>
  <div class="col-xs-4 col-md-1 text-center">
    <input
      type="checkbox"
      [(ngModel)]="attVisible"
      *ngIf="attVisibleFieldVisible"
      (change)="attVisCheckboxChanged($event)"
      [disabled]="attendeeRequiredDisabled"
    />
  </div>
  <div class="col-xs-4 col-md-1 text-center">
    <input
      type="checkbox"
      [(ngModel)]="attRequired"
      *ngIf="attVisibleFieldVisible && attRequiredVisible"
      (change)="attReqCheckboxChanged($event)"
      [disabled]="attendeeVisibleDisabled"
    />
  </div>
</div>
